import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import styles from './styles';

import { showDialog, hideDialog } from '../../../actions/dialogs';
import ItemTypeIcon from '../../Common/ItemTypeIcon';
import { sortStrings } from '../../../utils/helper';

class ItemTypesTable extends Component {
  static propTypes = {
    counts: PropTypes.object.isRequired,
    itemTypes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {
    itemTypes: [],
  };

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      itemTypes: _.values(nextProps.itemTypes).filter((itemType) => {
        return !nextProps.counts[itemType.id];
      }).sort((a,b) => sortStrings(a.name, b.name)),
    });
  }

  handleDiscard = () => {
    this.props.hideDialog('taskprofile');
  };

  handleSave = () => {
    console.log('handleSave');
  };

  handleRemoveItemType = (itemType) => {
    const context = {
      type: 'warning',
      title: 'Remove Item?',
      message: 'Are you sure you wish to remove this item?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => this.props.hideDialog('confirm')}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  handleDecreaseQty = (itemType) => {
    this.handleChangeQty(itemType, -1);
  };

  handleIncreaseQty = (itemType) => {
    this.handleChangeQty(itemType, 1);
  };

  handleChangeQty = (itemType, delta) => {
    console.log('Before', this.props.counts);
    const counts = _.pickBy(_.assign(this.props.counts, { [itemType.id]: this.props.counts[itemType.id] + delta }), (value) => value > 0);
    console.log('After', counts);
    this.props.onChange(counts);
  };

  renderItem = (itemType, quantity) => {
    if (!itemType) {
      return null;
    }

    console.log('itemType', itemType, quantity);
    return (<TableRow key={itemType.id} selectable={false}>
      <TableRowColumn style={styles.iconCol}>
        <ItemTypeIcon type={itemType} height={26}/>
      </TableRowColumn>
      <TableRowColumn style={styles.nameCol}>{itemType.name}</TableRowColumn>
      <TableRowColumn style={styles.quantityCol}>
        <FloatingActionButton mini style={styles.quantityIcon} onClick={() => this.handleDecreaseQty(itemType)} secondary>
          <FontIcon className="material-icons">remove</FontIcon>
        </FloatingActionButton>
        <span style={styles.count}>{quantity}</span>
        <FloatingActionButton mini style={styles.quantityIcon} onClick={() => this.handleIncreaseQty(itemType)} secondary>
          <FontIcon className="material-icons">add</FontIcon>
        </FloatingActionButton>
      </TableRowColumn>
    </TableRow>);
  };

  handleAddNewItemType = (evt, idx) => {
    const itemType = this.state.itemTypes[idx];
    this.props.onChange(_.assign(this.props.counts, { [itemType.id]: 1 }));
  };

  renderAddItemType() {
    const { itemTypes } = this.state;
    return (<TableRow key={'add'} selectable={false}>
      <TableRowColumn style={styles.iconCol}>
      </TableRowColumn>
      <TableRowColumn style={styles.nameCol}>
        <SelectField
          onChange={this.handleAddNewItemType}
          autoWidth
          hintText="Add new item..."
          fullWidth
        >
          { itemTypes.map((itemType) => {
            return (<MenuItem key={itemType.id} value={itemType} primaryText={itemType.name}/>);
          }) }
        </SelectField>
      </TableRowColumn>
      <TableRowColumn style={styles.quantityCol}>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const { itemTypes, counts } = this.props;
    if (!itemTypes) {
      return null;
    }

    return (<Table selectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={styles.iconCol}></TableHeaderColumn>
          <TableHeaderColumn style={styles.nameCol}>Name</TableHeaderColumn>
          <TableHeaderColumn style={styles.quantityCol}>Quantity</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {_.keys(counts).map((itemTypeId) => this.renderItem(this.props.itemTypes[itemTypeId], counts[itemTypeId]))}
        { this.renderAddItemType() }
      </TableBody>
    </Table>);
  }

}

function mapStateToProps(state) {
  return {
    itemTypes: state.get('itemtypes').get('itemTypes').toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemTypesTable);



// WEBPACK FOOTER //
// ./src/components/TaskProfile/ItemTypesTable/index.js